import { getOrderTrackerIconUrl } from "../utils/helpers";
import useSystemTrackerHook from "./useSystemTrackerHook";

const useBranchImageHook = (branchId: number) => {
  const { systemTrackerQuery } = useSystemTrackerHook(branchId);
  const url = getOrderTrackerIconUrl(
    branchId,
    systemTrackerQuery?.data?.icon_cloudinary_image_id
  );

  return {
    url,
    isPending: systemTrackerQuery.isPending,
  };
};

export default useBranchImageHook;
